import React from "react";
import {useNavigate, useParams} from "react-router-dom";
import Text from "../designSystem/Text";
import { Button, ButtonStyle } from "../designSystem/Button";

enum ErrorType {
    SERVER = 'serverError',
    PAGE_NOT_FOUND = 'pageNotFound',
}
const ErrorPage = () => {
    const { errorType } = useParams();
    const navigate = useNavigate();

    switch (errorType) {
        case ErrorType.SERVER:
            return (
                <div className={"flex flex-col gap-y-4 items-center"}>
                    <Text>Le service est temporairement indisponbile... Veuillez réessayer ultérieurement.</Text>
                    <Button buttonStyle={ButtonStyle.LINK} className={"w-fit"} onClick={() => navigate('/')}>Retourner à l'accueil</Button>
                </div>
            )

        default:
            return (
                <div className={"flex flex-col gap-y-4 items-center"}>
                    <Text>La page que vous cherchez n'existe pas !</Text>
                    <Button buttonStyle={ButtonStyle.LINK} className={"w-fit"} onClick={() => navigate('/')}>Retourner à l'accueil</Button>
                </div>
            )
    }

}

export default ErrorPage;